<template>
  <div>
    <v-row>
      <v-col sm="6">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dateValue"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dateValue"
                class="date-picker-custom"
                :label="label"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:prepend-inner="on.click"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateValue"
              no-title
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="menu = false"
            >
              Cancel
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="saveDate(dateValue)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col sm="5">
        <v-text-field
            v-model="timeValue"
            prepend-inner-icon="mdi-clock-time-four-outline"
            label="Time"
            readonly
            :disabled="!dateValue"
            @click="openTimePicker"
        />
      </v-col>
      <v-col sm="1">
        <v-btn
            v-if="date && time"
            icon
            class="mt-3"
            @click="dateValue = null; timeForPicker = null;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <datetime
        ref="time"
        v-model="timeForPicker"
        type="time"
        input-class="d-none"
        class="theme-red"
        use12-hour
    />
  </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
import moment from 'moment';

export default {
  name: 'DateTime',
  components: {
    Datetime,
  },

  props: {
    date: {
      type: String,
    },
    time: {
      type: String,
    },
    label: {
      type: String,
    },
    field: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      menu: false,
    };
  },

  computed: {
    dateValue: {
      get() {
        return this.date;
      },
      set(value) {
        this.$emit('update:date', value);
      },
    },
    timeForPicker: {
      get() {
        return `${this.date}T${this.time}`;
      },
      set(value) {
        let newValue = null;
        if (value) {
          newValue = moment(value).format('HH:mm:ss');
        }
        this.$emit('update:time', newValue);
      },
    },
    timeValue() {
      return this.date && this.time
        ? moment(`${this.date} ${this.time}`).format('hh:mm A')
        : null;
    },
  },
  methods: {
    /**
     * Handler of click by schedule date input.
     */
    openTimePicker(event) {
      if (!this.dateValue) {
        return;
      }
      this.$refs.time.open(event);
    },

    saveDate(date) {
      this.$refs.menu.save(date);
      if (date && !this.time) {
        this.$emit('update:time', '00:00:00');
      }
    },
  },
};
</script>
